<template>
  <el-dialog
    :title="$t('editAShopSms.edit')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <div class="modal-body">
      <div class="ibox-content">
        <el-form :model="editAShopSmsInfo" label-width="120px">
          <el-form-item :label="$t('editAShopSms.smsCount')" prop="smsCount">
            <el-input
              v-model="editAShopSmsInfo.smsCount"
              :placeholder="$t('editAShopSms.smsCountPlaceholder')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('editAShopSms.smsSwitch')" prop="smsSwitch">
            <el-select
              v-model="editAShopSmsInfo.smsSwitch"
              style="width:100%"
              :placeholder="$t('editAShopSms.smsSwitchPlaceholder')"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editAShopSms">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAShopSms } from '@/api/shop/shopSmsApi'

export default {
  name: 'EditAShopSms',
  data() {
    return {
      dialogVisible: false,
      editAShopSmsInfo: {
        smsId: '',
        shopId: '',
        smsSwitch: '',
        smsCount: ''
      },
      options: [
        { value: 'ON', label: this.$t('editAShopSms.on') },
        { value: 'OFF', label: this.$t('editAShopSms.off') }
      ]
    }
  },
  methods: {
    open(row) {
      this.editAShopSmsInfo = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.editAShopSmsInfo = {
        smsId: '',
        shopId: '',
        smsSwitch: '',
        smsCount: ''
      }
    },
    async editAShopSms() {
      if (!this.validateForm()) {
        return
      }

      try {
        const res = await updateAShopSms(this.editAShopSmsInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('editAShopSms.updateSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('更新店铺短信失败:', error)
        this.$message.error(this.$t('editAShopSms.updateFailed'))
      }
    },
    validateForm() {
      if (!this.editAShopSmsInfo.shopId) {
        this.$message.error(this.$t('editAShopSms.shopIdRequired'))
        return false
      }
      if (!this.editAShopSmsInfo.smsId) {
        this.$message.error(this.$t('editAShopSms.smsIdRequired'))
        return false
      }
      if (!this.editAShopSmsInfo.smsCount) {
        this.$message.error(this.$t('editAShopSms.smsCountRequired'))
        return false
      }
      if (!this.editAShopSmsInfo.smsSwitch) {
        this.$message.error(this.$t('editAShopSms.smsSwitchRequired'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 10px;
}
.ibox-content {
  padding: 15px;
}
</style>